<script setup>
const props = defineProps({
  authors: {
    type: Array,
    required: true
  }
})
</script>
<template>
  <div v-if="authors.length > 1" class="flex items-center gap-5">
      <div class="flex">
        <picture v-for="teacher in authors" :key="teacher.id" class="flex size-6 bg-secondary-30 -mr-2.5 rounded-full overflow-hidden">
          <img class="size-6 object-cover" :src="teacher.avatar"/>
        </picture>
      </div>
      <div class="text-sm text-secondary-70">
        Varios profesores
      </div>
  </div>
  <div v-if="authors.length === 1" class="flex items-center gap-2">
    <picture class="flex size-6 bg-secondary-30 rounded-full overflow-hidden">
      <img class="size-6 object-cover" onerror="this.classList.add('hidden')" :src="authors[0].avatar" alt="Avatar de profesor"/>
    </picture>
    <span class="text-xs text-secondary-70 flex gap-1">
      {{`${authors[0].first_name} ${authors[0].last_name}`}}
    </span>
  </div>
</template>